import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { IExtendSharingObjectItem } from '@fi-app/components/extend-sharing/extend-sharing';

@Component({
    selector: 'fi-extend-sharing-object',
    template: `
        <mat-card class="fi-content-card BrandedBorderColorTop top-border-card">
          <div class="fi-extend-sharing-object-heading-wrapper">
            <mat-icon [class]="headerIconClassName"></mat-icon>
            <span class="fi-extend-sharing-object-heading">{{ headerText }}</span>
          </div>
          <p class="fi-extend-sharing-object-description" [innerHTML]="descriptionText"></p>
          @for (selectionItem of items; track selectionItem) {
            <div>
              <mat-checkbox
                [(ngModel)]="selectionItem.isChecked"
                [disabled]="selectionItem.isDisabled"
                (ngModelChange)="onSelectionItemChange()"
                >
                {{ selectionItem.label }}
              </mat-checkbox>
            </div>
          }
        </mat-card>
        `,
    styleUrls: ['./extend-sharing-object.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-extend-sharing-object' },
    standalone: false,
})
export class ExtendSharingObjectComponent {
    @Input() items: IExtendSharingObjectItem[] = [];
    @Input() headerText: string;
    @Input() headerIconClassName: string;
    @Input() descriptionText: string;
    @Output() selectionChange = new EventEmitter<void>();

    constructor() {}

    onSelectionItemChange() {
        this.selectionChange.emit();
    }
}
